import React, { useContext, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Params } from '../types/old/params';
import CarDetails from './CarDetails';
import { styled } from '@volkswagen-onehub/components-core';
import Headline from '../components/VehicleCard/Headline';
import Msrp from './BuildPrice/Msrp';
import Pricing from './BuildPrice/Pricing';
import Photos from './CarDetails/Photos';
import useFetchFinancingRates from '../utils/use-fetch-financing-rates';
import Specifications from './CarDetails/Specifications';
import Loading from '../components/Loading';
import { useFeatureServices } from '../use-feature-services';
import { getLang } from '../translations';
import useRootHistory from '../utils/use-root-history';
import { createBreadcrumb } from '../utils/use-breadcrumbs';
import { VehicleData } from '../types';
import { VehicleInterface } from '@vw-marketing/vw-ca-types';
import { VehicleDetailsContext } from '../utils/details-context';

const MainDetailLayout = styled.div`
	margin: 0 var(--size-grid002) var(--size-grid002) var(--size-grid002);
	display: grid;
	grid-template-columns: minmax(50%, 1fr);
	grid-row-gap: var(--size-dynamic0150);

	@media screen and (min-width: 1040px) {
		grid-template-columns: minmax(50%, 2fr) 1fr;
		grid-template-rows: auto auto auto 1fr 1fr auto auto;
		grid-column-gap: var(--size-dynamic0050);
		grid-row-gap: ${props => props.theme.size.static150};
	}

	@media screen and (min-width: 1060px) {
		grid-column-gap: var(--size-dynamic0150);
	}
`;

export const DetailsPage = () => {
  const lang = getLang();
  const {
    "breadcrumb-service": breadcrumbService,
    "s2:history": history,
    'finance-provider-service': financeProvider
  } = useFeatureServices();

	const { vehicle, dealer } = useContext(VehicleDetailsContext);

  const params: Params = useParams();
	const navigate = useNavigate();
	useRootHistory();

	// fetch financialCalculator
	useFetchFinancingRates();

  useEffect(() => {
	  if (!vehicle || !breadcrumbService || !history) {
      return;
    };

    const breadcrumbs = breadcrumbService?.getBreadcrumbs(history.historyKey);
	  let detailsBreadcrumbs = vehicle.year + ' ' + vehicle.model_name + ' ' + vehicle.trim[lang];
    if (lang === 'fr') {
      detailsBreadcrumbs = vehicle.model_name + ' ' + vehicle.trim[lang] + ' ' + vehicle.year;
    }

    breadcrumbService?.set([
      ...breadcrumbs,
      createBreadcrumb(
        history.rootHistory,
        {
          pathname: '/',
          search: params.toString()
        },
        detailsBreadcrumbs ? detailsBreadcrumbs : '',
        () => navigate({
          pathname: '/details',
          search: params.toString()
        })
      )
    ]);

    // passing pcs data to payment estimator before opened
    if (financeProvider && vehicle && vehicle.pcs) {
      financeProvider.set(vehicle as VehicleInterface, (vehicle as VehicleInterface).pcs[lang]);
    };
  }, [vehicle]);

	return vehicle ? (
		<React.Fragment>
			<MainDetailLayout>
				<Headline vehicle={vehicle as VehicleData} dealer={dealer} isDetailPage={true} />
				<Photos vehicle={vehicle} />
				<Msrp vehicle={vehicle} />
				<CarDetails vehicle={vehicle} />
				<Pricing />
				<Specifications vehicle={vehicle} />
			</MainDetailLayout>
		</React.Fragment>
  	) : <Loading />;
};
